import { UIComponentHandler, UIComponentImpl, UIComponentState, UIDataModel, UIComponentProps } from '../../../../toolkit/uicomponent';
import { BaseContext } from '../../../../../utils/basecontext';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { ToneDto } from '../../../../../core/dto/tonedto';
import { ListViewModel } from '../../../../toolkit/horizontallist/listviewmodel';
import { SearchAPIModelImpl } from '../searchapimodel';
import { APIModelHandler, APIModel } from '../../../../toolkit/uicomponentapimodel';
import { ArtistTabSearchListViewImpl } from './artistsearchlistview';
import { ArtistTabSearchListCSSStyleImpl } from './artistsearchlistcss';

export interface ArtistTabSearchListComponentProps extends UIComponentProps
{
    listViewModel: ListViewModel<ToneDto>;

    onLoadMore(startIndex: number, offset: number): void;
}


export interface ArtistTabSearchlistComponentHandler extends UIComponentHandler
{
    onLoadMore(startIndex: number, offset: number): void;
}


export class ArtistTabSearchListComponent extends UIComponentImpl<ArtistTabSearchListComponentProps, UIComponentState, UIDataModel> 
implements ArtistTabSearchlistComponentHandler
{
    constructor(props: ArtistTabSearchListComponentProps)
    {
        super(props);

        this.onLoadMore = this.onLoadMore.bind(this);
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ArtistTabSearchListViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new ArtistTabSearchListCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return  new SearchAPIModelImpl(applicationContext, apiModelHandler);
    }

    updatePaginationCount()
    {
        (this.getView() as ArtistTabSearchListViewImpl).updatePaginationCount();
    }

    resetPaginationCount()
    {
        (this.getView() as ArtistTabSearchListViewImpl).resetPaginationCount();
    }

    // updateListOfData(listOfDatas: ToneDto[])
    // {
    //     this.props.listViewModel.getListOfDatas().length = 0;
    //     this.props.listViewModel.setListDatas(listOfDatas);

    //     this.forceUpdateComponent();
    // }

    // onSuccess(feature: APIFeatures, description: string, data: any): void 
    // {
    //     console.log("----title: " + this.props.title);
    //     if(this.props.title === this.props.context.getResources().getString(Strings.tones))
    //     {
    //         this.updateListOfData((data as SpecificSearchToneDto).getToneList());
    //         (this.getView() as ArtistSearchListViewImpl).updatePaginationCount();
    //     }
    //     // else
    //     // {
    //     //     this.updateListOfData((data as SpecificSearchToneDto).getCountList().getArtistDetailList());
    //     //     (this.getView() as ArtistSearchListViewImpl).updatePaginationCount();
    //     // }
    // }

    onLoadMore(startIndex: number, offset: number): void 
    {
        this.props.onLoadMore(startIndex, offset);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/search/artist/artistsearchlistcomponent.tsx